/* ============================================
   Artemis Theme — Header Designer Count
   ============================================
   Mirrors DesignerSession.count() into the
   header / mobile-drawer "Apparel Designer"
   buttons. Runs on every page (loaded globally
   from theme.liquid), so the badge stays current
   as the customer adds products from apparel PDPs
   or removes them in the designer — and across
   tabs via DesignerSession's storage listener.
   ============================================ */

(function () {
  'use strict';

  function render() {
    if (!window.DesignerSession) return;
    var count = window.DesignerSession.count();
    var badges = document.querySelectorAll('[data-designer-count]');
    badges.forEach(function (badge) {
      if (count > 0) {
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.removeAttribute('hidden');
      } else {
        badge.setAttribute('hidden', '');
      }
    });
  }

  function init() {
    if (!window.DesignerSession) return;
    render();
    // Same-tab updates (add/remove/clear) emit 'change'; cross-tab updates
    // arrive through DesignerSession's own window 'storage' listener, which
    // also re-emits 'change'. One subscription covers both.
    window.DesignerSession.on('change', render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
